import { render } from "./CompanyManagement.vue?vue&type=template&id=59e2dc38&scoped=true"
import script from "./CompanyManagement.vue?vue&type=script&lang=js"
export * from "./CompanyManagement.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-59e2dc38"

export default script